import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import _ from "lodash";

import BackgroundBlock from "../../deliveryNotes/partials/BackgroundBlock";
import Input from "components/Input";
import InputFile from "components/InputFile";
import CNBTextArea from "components/CNBTextArea";
import Button from "components/Button";
import CNBDatePicker from "components/CNBDatePicker";
import { ICustomer, IUser } from "models/.";
import Actions from "../actions";

interface IProps {
  currentCustomer: ICustomer;
  user: IUser;
  onBackClick: () => void;
  sendContactForm: (params) => void;
  intl: any;
}

interface IState {
  [key: string]: any;
  error: any;
  touched: any;
}

class ContactForm extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    const {
      user,
      currentCustomer: { Name, Number }
    } = props;

    this.state = {
      name: Name,
      topic: "",
      number: Number,
      user: _.get(user, "profile.preferred_username"),
      error: {},
      touched: {}
    };
  }

  private handleInputChange = e => {
    const { name, value, validity } = e.target;
    const { error, touched } = this.state;
    const {
      intl: { formatMessage }
    } = this.props;
    touched[name] = true;
    error[name] =
      !validity.valid && validity.valueMissing
        ? formatMessage({ id: "VALIDATION_REQUIRED" })
        : !validity.valid && (validity.typeMismatch || validity.patternMismatch)
          ? formatMessage({ id: "VALIDATION_EMAIL" })
          : null;
    this.setState({ [name]: value, error, touched });
  };

  private handleFileChange = ([attachment]) => this.setState({ attachment });

  private handleFileRemove = () =>
    this.setState(() => ({ attachment: undefined }));

  private handleDatepickerChange = date => this.setState({ date });

  private handleSubmit = e => {
    const {
      currentCustomer: { Name, Number },
      user,
      sendContactForm
    } = this.props;
    const defaultValues = {
      number: Number,
      name: Name,
      user: _.get(user, "profile.preferred_username"),
      date: new Date(),
      lang: _.get(user, "profile.Language", "nl")
    };
    const formData = new FormData();
    const data = { ...defaultValues, ...this.state };

    e.preventDefault();
    _.forEach(data, (value, key) => formData.append(key, value));
    sendContactForm(formData);
    this.setState({ topic: "", text: "", attachment: undefined });
  };

  public render() {
    const { onBackClick } = this.props;
    const {
      name,
      number,
      user,
      topic,
      text,
      error,
      touched,
      attachment
    } = this.state;
    const isDisabled = error.number || error.name || error.user || error.topic;

    return (
      <form id="new-cultivation-advice" onSubmit={this.handleSubmit}>
        <BackgroundBlock className="advice-form">
          <Input
            onChange={this.handleInputChange}
            name="number"
            label="CLIENT_NR"
            placeholder="CLIENT_NR"
            value={number}
            meta={{ error: error.number, touched: touched.number }}
            required
          />
          <Input
            onChange={this.handleInputChange}
            name="name"
            label="CLIENT_NAME"
            placeholder="CLIENT_NAME"
            value={name}
            meta={{ error: error.name, touched: touched.name }}
            required
          />
          <Input
            onChange={this.handleInputChange}
            name="user"
            label="CONTACT_USER"
            placeholder="CONTACT_USER"
            value={user}
            meta={{ error: error.user, touched: touched.user }}
            type="email"
            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
            required
          />
          <div className="datum">
            <FormattedMessage id="DATE" tagName="label" />
            <CNBDatePicker
              startDate={this.state.date || new Date()}
              onChange={this.handleDatepickerChange}
            />
          </div>
          <Input
            onChange={this.handleInputChange}
            name="topic"
            label="CONTACT_SUBJECT"
            placeholder="CONTACT_SUBJECT"
            value={topic}
            meta={{ error: error.topic, touched: touched.topic }}
            required
          />
          <CNBTextArea
            onChange={this.handleInputChange}
            name="text"
            value={text}
            label="CONTACT_TEXT"
            rows={6}
          />
          <InputFile
            name="attachment"
            label="CONTACT_FILES"
            files={attachment ? [attachment] : []}
            remove={this.handleFileRemove}
            onChange={this.handleFileChange}
          />
        </BackgroundBlock>
        <div className="submit-btn">
          <Button kind="gray" onClick={() => onBackClick()} type="button">
            CANCEL
          </Button>
          <Button id="submit-contact-form" kind="primary" disabled={isDisabled}>
            SUBMIT
          </Button>
        </div>
      </form>
    );
  }
}

export default connect(
  null,
  {
    sendContactForm: Actions.sendContactForm
  }
)(injectIntl(ContactForm));
